import * as actions from "./actionTypes";

export * from "./actionTypes";
type AnalyticsProperties =
  | {
      location: string;
    }
  | {
      location: string;
      type: string;
    }
  | {
      location: string;
      type: string;
      age: number;
    }
  | {
      location: string;
      type: string;
      age: number;
    };
type Meta = {
  analytics: {
    type: string;
    properties: AnalyticsProperties;
  };
};
type AddEmployeeAction = {
  type: typeof actions.ADD_EMPLOYEE;
  meta: Meta;
};
export function addEmployee(location: string): AddEmployeeAction {
  return {
    type: actions.ADD_EMPLOYEE,
    meta: {
      analytics: {
        type: "employee_added",
        properties: {
          location,
        },
      },
    },
  };
}
type RemoveEmployeeAction = {
  type: typeof actions.REMOVE_EMPLOYEE;
  index: number;
  meta: Meta;
};
export function removeEmployee(index: number, location: string): RemoveEmployeeAction {
  return {
    type: actions.REMOVE_EMPLOYEE,
    index,
    meta: {
      analytics: {
        type: "employee_removed",
        properties: {
          location,
        },
      },
    },
  };
}
type AddSpouseAction = {
  type: typeof actions.ADD_SPOUSE;
  index: number;
  meta: Meta;
};
export function addSpouse(index: number, location: string): AddSpouseAction {
  return {
    type: actions.ADD_SPOUSE,
    index,
    meta: {
      analytics: {
        type: "family_added",
        properties: {
          type: "spouse",
          location,
        },
      },
    },
  };
}
type RemoveSpouseAction = {
  type: typeof actions.REMOVE_SPOUSE;
  index: number;
  meta: Meta;
};
export function removeSpouse(index: number, location: string): RemoveSpouseAction {
  return {
    type: actions.REMOVE_SPOUSE,
    index,
    meta: {
      analytics: {
        type: "family_removed",
        properties: {
          type: "spouse",
          location,
        },
      },
    },
  };
}
type AddChildAction = {
  type: typeof actions.ADD_CHILD;
  index: number;
  meta: Meta;
};
export function addChild(index: number, location: string): AddChildAction {
  return {
    type: actions.ADD_CHILD,
    index,
    meta: {
      analytics: {
        type: "family_added",
        properties: {
          type: "child",
          location,
        },
      },
    },
  };
}
type RemoveChildAction = {
  type: typeof actions.REMOVE_CHILD;
  index: number;
  childIndex: number;
  meta: Meta;
};
export function removeChild(index: number, childIndex: number, location: string): RemoveChildAction {
  return {
    type: actions.REMOVE_CHILD,
    index,
    childIndex,
    meta: {
      analytics: {
        type: "family_removed",
        properties: {
          type: "child",
          location,
        },
      },
    },
  };
}
type UpdateEmployeeAgeAction = {
  type: typeof actions.UPDATE_EMPLOYEE_AGE;
  index: number;
  age: number;
  meta: Meta;
};
export function updateEmployeeAge(index: number, age: number, location: string): UpdateEmployeeAgeAction {
  return {
    type: actions.UPDATE_EMPLOYEE_AGE,
    index,
    age,
    meta: {
      analytics: {
        type: "ages_entered",
        properties: {
          age,
          type: "employee",
          location,
        },
      },
    },
  };
}
type UpdateSpouseAgeAction = {
  type: typeof actions.UPDATE_SPOUSE_AGE;
  index: number;
  age: number;
  meta: Meta;
};
export function updateSpouseAge(index: number, age: number, location: string): UpdateSpouseAgeAction {
  return {
    type: actions.UPDATE_SPOUSE_AGE,
    index,
    age,
    meta: {
      analytics: {
        type: "ages_entered",
        properties: {
          age,
          type: "spouse",
          location,
        },
      },
    },
  };
}
type UpdateChildAgeAction = {
  type: typeof actions.UPDATE_CHILD_AGE;
  index: number;
  childIndex: number;
  age: number;
  meta: Meta;
};
export function updateChildAge(index: number, age: number, childIndex: number, location: string): UpdateChildAgeAction {
  return {
    type: actions.UPDATE_CHILD_AGE,
    index,
    childIndex,
    age,
    meta: {
      analytics: {
        type: "ages_entered",
        properties: {
          age,
          type: "child",
          location,
        },
      },
    },
  };
}
export function replaceEmployeeProfile(newEmployeeProfile) {
  return {
    type: actions.REPLACE_EMPLOYEE_PROFILE,
    payload: newEmployeeProfile,
  };
}
export function validateEmployeeProfile() {
  return {
    type: actions.VALIDATE_EMPLOYEE_PROFILE,
  };
}
export function persistEmployeeProfile(companyIDToken) {
  return {
    type: actions.PERSIST_EMPLOYEE_PROFILE,
    payload: {
      companyIDToken,
    },
  };
}
type UpdateOverallErrorMessageAction = {
  type: typeof actions.UPDATE_CHILD_AGE;
  errorMessage: string;
};
export function updateOverallErrorMessage(errorMessage: string): UpdateOverallErrorMessageAction {
  return {
    type: actions.UPDATE_OVERALL_ERROR_MESSAGE,
    errorMessage,
  };
}
export type EnterAgesAction =
  | AddEmployeeAction
  | RemoveEmployeeAction
  | AddSpouseAction
  | RemoveSpouseAction
  | AddChildAction
  | RemoveChildAction
  | UpdateEmployeeAgeAction
  | UpdateSpouseAgeAction
  | UpdateChildAgeAction
  | UpdateOverallErrorMessageAction;
